/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Ready_TitleInputs */



/**
* | output |
* | --- |
* | "Set up for you" |
*
* @param {Tournament_Wiz_Ready_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_ready_title = /** @type {((inputs?: Tournament_Wiz_Ready_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Ready_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préparé pour vous")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preparado para usted")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Preparado para você")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preparato per te")
	return /** @type {LocalizedString} */ ("Set up for you")
});